<template>
  <div>
    <v-container fluid class="pt-0">
      <v-row>
        <v-col cols="12">
          <v-tabs
            v-model="tab"
            centered
            class="tab-custom">
            <v-tab v-for="item in items" :key="item.tab" class="caption">{{ item.tab }}</v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <v-tab-item v-for="item in items" :key="item.tab">
              <v-card flat>
                <component :is="item.component" :dates="dates" :period="period">
                  <router-view></router-view>
                </component>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ClientsReports from './partials/ClientsReports'
import PurchasesReports from './partials/PurchasesReports'
import HrReports from './partials/HrReports'

export default {
  props: {
    dates: {
      type: Array,
      required: true
    },
    period: {
      type: String,
      required: true
    }
  },
  components: {
    'clients-reports': ClientsReports,
    'purchases-reports': PurchasesReports,
    'hr-reports': HrReports
  },
  data () {
    return {
      tab: null,
      items: [
        { tab: 'Ventas', component: 'clients-reports' },
        { tab: 'Compras', component: 'purchases-reports' }
        // { tab: 'Recursos humanos', component: 'hr-reports' }
      ]
    }
  }
}
</script>
